<span>
    <span class="flag-icon" [ngClass]="'flag-icon-'+item.pays.code2.toLowerCase()" *ngIf="item.pays"></span>
    <span class="m-l-10">{{ options.displayItem(item) }}</span>
</span>